"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerResponseFilter = exports.registerRequestFilter = exports.getResponseFilter = exports.getRequestFilter = exports.clearResponseFilter = exports.clearRequestFilter = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _pipe = _interopRequireDefault(require("../pure-functions/pipe"));

var defaultRequestFilterArray = [function (request) {
  return request;
}];
var defaultResponseFilterArray = [function (res) {
  return res;
}];
var requestFilterArray = [].concat(defaultRequestFilterArray);
var responseFilterArray = [].concat(defaultResponseFilterArray);

var registerRequestFilter = function registerRequestFilter(func) {
  requestFilterArray.push(func);
};

exports.registerRequestFilter = registerRequestFilter;

var registerResponseFilter = function registerResponseFilter(func) {
  responseFilterArray.push(func);
};

exports.registerResponseFilter = registerResponseFilter;

var clearRequestFilter = function clearRequestFilter() {
  requestFilterArray = [].concat(defaultRequestFilterArray);
};

exports.clearRequestFilter = clearRequestFilter;

var clearResponseFilter = function clearResponseFilter() {
  responseFilterArray = [].concat(defaultResponseFilterArray);
};

exports.clearResponseFilter = clearResponseFilter;

var getRequestFilter = function getRequestFilter() {
  return _pipe["default"].apply(void 0, (0, _toConsumableArray2["default"])(requestFilterArray));
};

exports.getRequestFilter = getRequestFilter;

var getResponseFilter = function getResponseFilter() {
  return _pipe["default"].apply(void 0, (0, _toConsumableArray2["default"])(responseFilterArray));
};

exports.getResponseFilter = getResponseFilter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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